import React from "react";
import file from "../../src/CV_Mustafa Altaş_Frontend Developer.docx";
import AnimatedPage from "../animated/AnimatedPage";
import "./style/skills.css";

function Skills() {
  return (
    <AnimatedPage>
      <div className="cv">
        <a href={file} download>
          <div className="doc">
            <div className="word"></div>
            <div className="layer layer--1"></div>
            <div className="layer layer--2"></div>
            <div className="layer layer--3" style={{paddingTop:"1rem"}}>Click Me!</div>
            <div className="layer layer--4"></div>
          </div>
        </a>
      </div>
    </AnimatedPage>
  );
}

export default Skills;
